import Icon from './Icon';
export default Icon;


// WEBPACK FOOTER //
// ./src/packages/Icon/index.js